import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOption } from '@angular/material/core';
import { MatDatepicker,MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose,MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatHint,MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';

import { UpdateSubscriptionInput } from 'app/shared/graph';

@Component({
    selector: 'admin-update-subscription-billing-dialog',
    templateUrl: 'update-subscription-billing-dialog.component.html',
    styleUrls: ['update-subscription-billing-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatSelect, MatOption, MatCheckbox, MatHint, MatDialogActions, MatButton, MatDialogClose]
})
export class UpdateSubscriptionBillingDialogComponent {
    dialogRef = inject<MatDialogRef<UpdateSubscriptionBillingDialogComponent>>(MatDialogRef);
    data = inject<UpdateSubscriptionInput>(MAT_DIALOG_DATA);

    currencyPattern = /^[A-Z]{3}$/;
}
